import React from 'react';
// import { dataRef } from "./Firebase";
import '../Pract.css';
// import { ref, onValue } from 'firebase/database';
// import StartFirebase from './Firebase';

const Pract = ()=>{
    // const [name, setName] = useState({nam: 'Piyush Ramani', adress: 'Rani Bag, Indore',});
    const WriteData=()=>{
        // dataRef.ref().child("All").push().child("name").set(name.nam);
        // dataRef.ref().child("All").push().child("name, address").set(name.nam, name.adress);
        }








        






    return(
        <>
        <div className="mydiv">
            <div className="div1">hh</div>
            <div className="div2">jjjh</div>
            
        </div>
        <div>
            <button onClick={WriteData}>Piyush</button>
        </div>
        </>
    );
}

export default Pract;